"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const prop_types_1 = require("prop-types");
const intl_1 = require("@kyruus/intl");
const calendar_1 = require("@kyruus/calendar");
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../../lib/messages"));
const id = 'jumpToDateCalendar';
const BaseDatePicker = ({ date, onDateChange, onClose, intl, placeholder }) => {
    const [calendarFocused, setCalendarFocused] = (0, react_1.useState)(false);
    const handleDateChange = (date) => {
        // if the date entered is not a valid date, date will be null
        if (date == null)
            return;
        onDateChange(date);
    };
    const handleEscape = (event) => {
        if (event.key === 'Escape')
            setCalendarFocused(false);
        if (onClose)
            onClose(event);
    };
    (0, react_1.useEffect)(() => {
        var _a;
        // Event doesn't propagate from the SingleDatePicker
        // and SingleDatePicker doesn't support passing in a
        // key handler. Attach the event directly instead.
        (_a = document.querySelector(`#${id}`)) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', handleEscape);
        return () => {
            var _a;
            (_a = document
                .querySelector(`#${id}`)) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', handleEscape);
        };
    }, []);
    return (react_1.default.createElement(styles_1.DatePicker, { "aria-label": intl.formatMessage(messages_1.default.ariaJumpToDateCalendarButton), "data-testid": "jumpToDateCalendarContainer", className: date ? 'active' : null, onKeyDown: handleEscape },
        react_1.default.createElement(calendar_1.SingleDatePicker, { ariaLabel: intl.formatMessage(messages_1.default.ariaJumpToDateCalendarInput), date: (date && (0, moment_1.default)(date)) || null, focused: calendarFocused, hideKeyboardShortcutsPanel: true, id: id, inputIconPosition: "after", numberOfMonths: 1, onDateChange: handleDateChange, onFocusChange: ({ focused }) => setCalendarFocused(focused), placeholder: placeholder ||
                intl.formatMessage(messages_1.default.apptTimeCalendarPlaceholder), screenReaderInputMessage: intl.formatMessage(messages_1.default.ariaJumpToDateInputDescription), showDefaultInputIcon: true, small: true, readOnly: true })));
};
BaseDatePicker.defaultProps = {
    date: null
};
BaseDatePicker.propTypes = {
    date: prop_types_1.string,
    onDateChange: prop_types_1.func.isRequired,
    onClose: prop_types_1.func,
    intl: (0, prop_types_1.shape)({
        formatMessage: prop_types_1.func.isRequired
    }),
    placeholder: prop_types_1.string
};
exports.default = (0, intl_1.injectIntl)(BaseDatePicker);
//# sourceMappingURL=DatePicker.js.map